<ng-template #defaultTabButtons let-c="close" let-d="dismiss">
    <div class="text-white backgroundTable">
        <div class=" mx-5 ">
            <div class="row  my-2">
                <div *ngIf="edit" class="col-9 p-2 bd-highlight">Editar {{itemName}}</div>
                <div *ngIf="!edit" class="col-9 p-2 bd-highlight">Crear {{itemName}}</div>

                <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus
                        aria-label="Close" (click)="d('Cross click')" class="btn btn-outline-danger">Cerrar</button>
                </div>
            </div>
        </div>
        <div *ngIf="type == 'editRisk' || type == 'createRisk'">
            <div class="font-size-12">
                <form [formGroup]="riskForm">
                    <div class="row mx-5">
                        <div class="col-12mt-3">
                            <label class="mb-1">Etapa:</label>
                        </div>
                    </div>
                    <div class="row mx-5">
                        <div class="col-12 " >
                            <select class="form-select custom-outline-input" aria-label="Default select example"
                                id="dependence" formControlName="dependence">
                                <option value="0">Seleccionar tipo</option>
                                <option *ngFor="let dato of viewRisk.listDependence, let i = index" [ngValue]="dato">
                                    {{dato[i].name}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mx-5">
                        <div class="col-12 mt-3">
                            <label class="mb-1">Nombre:</label>
                        </div>
                    </div>
                    <div class="row mx-5">
                        <div class="col-12">
                            <input class="custom-input" formControlName="name" required>
                        </div>
                        <span *ngIf="validField('name', riskForm)" class="text-danger font-size-10">*Campo
                            obligatorio</span>
                    </div>
                    <div class="row mx-5">
                        <div class="col-12 mt-3">
                            <label class="mb-1">Descripción:</label>
                        </div>
                    </div>
                    <div class="row mx-5">
                        <div class="col-12 ">
                            <textarea class="form-control custom-input" type="text" row="3"
                                formControlName="description" id=""></textarea>
                        </div>
                    </div>

                    <div class="row mx-5">
                        <div class="col-6 ">
                            <label class="mb-1 mt-3">Fecha Activación</label>
                        </div>
                        <div class="col-6 ">
                            <label class="mb-1 mt-3">Fecha Deadline</label>
                        </div>

                    </div>
                    <div class="row mx-5">
                        <div class="col-5 ">
                            <input class="custom-input" placeholder="dd/mm/yyyy" formControlName="dateStart"
                                ngbDatepicker [(ngModel)]="model2">
                            <button class="btn btn-outline-secondary calendar" type="button"></button>
                        </div>
                        <div class="col-5 ">
                            <input class="custom-input" placeholder="dd/mm/yyyy" formControlName="dateEnd"
                                ngbDatepicker>
                            <button class="btn btn-outline-secondary calendar" type="button"></button>
                        </div>
                    </div>

                    <div class="row mx-5">
                        <div class="col-6 ">
                            <label class="mb-1 mt-3">Probabilidad</label>
                        </div>
                        <div class="col-6 ">
                            <label class="mb-1 mt-3">Impacto</label>
                        </div>
                    </div>

                    <div class="row mx-5">
                        <div class="col-6 ">
                            <input class="custom-input" formControlName="probability">
                        </div>
                        <div class="col-6 ">
                            <input class="custom-input" formControlName="impact">
                        </div>
                    </div>


                    <div class="row mx-5">
                        <div class="col ">
                            <label class="mb-1 mt-3">Responsable</label>
                        </div>
                    </div>
                    <div class="row mx-5">
                        <div class="col-12 " >
                            <select formControlName="assigned" class="form-select custom-outline-input" >
                                <option value=""></option>
                            </select>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="text-end">
            <button *ngIf="edit" type="button" class="btn btn-outline-light m-5">Guardar</button>
            <button *ngIf="!edit" type="button" class="btn btn-outline-light m-5">Crear</button>
        </div>
    </div>

</ng-template>